import Navbar from "@/components/Navbar";
import { AppLayout } from "@/components/layout/AppLayout";
import { PageContainer } from "@/components/layout/PageContainer";
import { FullCalendarView } from "@/components/owner/FullCalendarView";

export default function CalendarPage() {
  return (
    <AppLayout>
      <Navbar />
      <PageContainer className="py-4 sm:py-6">
        <FullCalendarView />
      </PageContainer>
    </AppLayout>
  );
}
